import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'

export default createVuetify({
  components,           // 👈 registra componentes
  directives,           // 👈 registra directivas
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi }
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#1e88e5',
          secondary: '#26c6da',
          success: '#43a047',
          warning: '#fb8c00',
          error: '#e53935'
        }
      }
    }
  }
})
